import React from 'react';
import { useDispatch } from 'react-redux';

import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';

import { openConfirmDialog } from '../../../store/dialogs';
import { putNiagara } from '../../../store/demand';

// ─── ConnectorSwitch ────────────────────────────────────────────────────────────
// Toggles a Niagara connector's active state, with a confirm dialog.
// Used to isolate field-device testing to a single org.

export default function ConnectorSwitch({ niagara, orgName, size = 'small' }) {
  const dispatch = useDispatch();

  if (!niagara) return null;

  const handleToggle = () => {
    const next = !niagara.active;
    dispatch(
      openConfirmDialog({
        title: `${next ? 'Activate' : 'Deactivate'} Connector`,
        message: (
          <p>
            {next ? (
              "Re-enable this org's Niagara connector? Field devices will resume normal operation."
            ) : (
              <>
                Deactivate this org's Niagara connector? Field devices for{' '}
                <strong>{orgName}</strong> will be marked inactive on their
                next poll — use this to isolate testing to a single org.
              </>
            )}
          </p>
        ),
        onConfirm: () =>
          dispatch(
            putNiagara({
              active: next,
              devices: niagara.devices,
              niagara_id: niagara.niagara_id,
              org_id: niagara.org_id,
            })
          ),
      })
    );
  };

  return (
    <Tooltip
      title={
        niagara.active
          ? 'Connector active — click to deactivate for testing'
          : 'Connector inactive — click to reactivate'
      }>
      <Switch
        size={size}
        checked={niagara.active}
        onChange={handleToggle}
        color='success'
      />
    </Tooltip>
  );
}